import { FieldLines } from './Field';
import { logo } from '../lib/logo';
import { useAfterPaint } from '../lib/useAfterPaint';
import { teamColor } from '../lib/colors';
import type { TeamSide } from '../lib/api';

/** A team's colors as a split band; used behind matchup headers. */
export function duotoneBand(away: Partial<TeamSide>, home: Partial<TeamSide>): React.CSSProperties {
  const a = teamColor(away.color), h = teamColor(home.color, '#0F4C81');
  return { background: `linear-gradient(104deg, ${a} 0%, ${a} 44%, ${h} 56%, ${h} 100%)` };
}

/** Oversized club marks bleeding off the edges of a colored header. */
export function MatchupMarks({ away, home }: { away: Partial<TeamSide>; home: Partial<TeamSide> }) {
  const painted = useAfterPaint();
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {/* hidden on phones, where an oversized crest would sit on top of the matchup */}
      {/*
        Texture, not content, and held back until the page has painted.

        These are crests drawn at 240% height, which made them the largest element
        on the page and therefore what Largest Contentful Paint measured. Resizing
        them took the download to 402ms, but Cloudflare still showed 6.1 seconds of
        Resource Load Delay out of an 8 second LCP: in a client-rendered app the URL
        is not known until the JS has run and the API has answered, and marking them
        lazy and low priority pushed them further back still.

        Rendering them only after the first paint lets the headline and the real
        logos be what gets measured.
      */}
      {painted && away.logo && <img src={logo(away.logo, 250)} alt="" decoding="async"
        className="absolute -left-16 top-1/2 hidden h-[240%] -translate-y-1/2 object-contain opacity-25 mix-blend-luminosity md:block" />}
      {painted && home.logo && <img src={logo(home.logo, 250)} alt="" decoding="async"
        className="absolute -right-16 top-1/2 hidden h-[240%] -translate-y-1/2 object-contain opacity-25 mix-blend-luminosity md:block" />}
      <FieldLines />
      <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent" />
    </div>
  );
}
